import React from 'react';
import Nav from '../../components/Nav/Nav.js';
import VideogameDetail from '../../components/VideogameDetail/VideogameDetail.js';

import './Detail.css'

export default function Detail(){
    return(
        <div className=''>
            <Nav className=''/>
            <VideogameDetail/>
        </div>
    )
}